module.exports = __webpack_public_path__ + "img/logo-white.72ee0f0d.svg";